module.exports = __webpack_public_path__ + "img/img16.01a4ac95.jpg";